<script setup>
import { ref, watchEffect, onMounted } from 'vue'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import FilterContents from './FilterContents'
import Overlay from '@/Shared/Overlay'
import Icon from '@/Shared/Icons/Icon'

const html = ref()
const open = ref(false)
const activeCategory = ref('brand')

const categories = [
  { id: 'brand', name: 'BRAND' },
  { id: 'store', name: 'STORE' },
]

const changeCategory = (id) => {
  if (!open.value) {
    open.value = true
    activeCategory.value = id
  } else {
    activeCategory.value = activeCategory.value === 'brand' ? 'store' : 'brand'
  }
}

const setCategory = () => {
  const url = location.href
  activeCategory.value = url.includes('all?brands=') ? 'brand' : 'store'
}

const toggleOpen = () => {
  open.value = !open.value
  setCategory()
}

defineExpose({ toggleOpen })

onMounted(() => {
  html.value = document.getElementsByTagName('html')[0]
  watchEffect(() => {
    if (open.value === true) {
      html.value.classList.add('filter-open')
    } else {
      html.value.classList.remove('filter-open')
    }
  })
})
</script>

<template>
  <div :class="{ 'overflow-y-scroll pl-[50px]': open }" class="fixed z-40 h-full top-0 right-0 scrollbar-hidden">
    <div class="bg-white flex items-start h-full shadow-[-2px_0px_10px_rgba(0,0,0,0.15)] overflow-x-hidden">
      <!-- tab -->
      <ul class="absolute flex rounded-b-[5px] overflow-hidden text-center translate-x-[1px] bg-white rotate-90 top-[100px] sm:top-[150px] origin-top-left shadow-[-2px_0px_10px_rgba(0,0,0,0.15)]">
        <li>
          <a class="flex h-full px-[10px]" href="#" @click.prevent="changeCategory('brand')">
            <Icon type="settings" class="w-[10px] h-auto" />
          </a>
        </li>
        <li v-for="category in categories" :key="category.id" class="border-l border-[#ddd] items-center justify-center flex h-full">
          <a class="block font-rift font-bold text-[15px] sm:text-[16px] py-[8px] sm:py-[10px] px-[12px] sm:px-[14px] tracking-[0.01em]" :class="{ 'bg-[#ccc] text-[#333]': activeCategory !== category.id && open }" href="#" @click.prevent="changeCategory(category.id)">
            {{ category.name }}
          </a>
        </li>
      </ul>

      <!-- contents -->
      <transition name="slide-filter">
        <template v-if="open">
          <div class="relative max-w-[450px] w-[90vw] bg-white flex items-center flex-col overflow-x-hidden h-full">
            <ButtonClose class="absolute z-10 black top-0 right-0 p-[20px] origin-top-right scale-[1.5]" @click="toggleOpen" />
            <transition name="slide-right2">
              <template v-if="activeCategory === 'brand'"><FilterContents category="brand" /></template>
            </transition>
            <transition name="slide-left2">
              <template v-if="activeCategory === 'store'"><FilterContents category="shop" /></template>
            </transition>
          </div>
        </template>
      </transition>
    </div>
  </div>

  <transition name="fade">
    <Overlay v-if="open" class="z-30" @click="toggleOpen" />
  </transition>
</template>
